import styled from 'styled-components';
export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  opacity: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 0.3 : 1;
}};
`;
export const Content = styled.div`
  background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.secondary;
}};

  border-radius: 10px;
  height: ${_ref3 => {
  let {
    minHeight
  } = _ref3;
  return minHeight;
}}px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 14px;

  cursor: ${_ref4 => {
  let {
    disabled
  } = _ref4;
  return disabled ? 'not-allowed' : 'pointer';
}};

  border: 1px solid transparent;

  &:hover {
    border: 1px solid ${_ref5 => {
  let {
    theme,
    disabled
  } = _ref5;
  return disabled ? 'transparent' : theme.colors.secondaryL3;
}};
  }

  &:focus {
    outline: none;
    border: 1px solid ${_ref6 => {
  let {
    theme,
    disabled
  } = _ref6;
  return disabled ? 'transparent' : theme.colors.secondaryL3;
}};
  }
`;
export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 4px;
  flex-wrap: wrap;
  max-width: 80%;
`;
export const Title = styled.h3`
  ${_ref7 => {
  let {
    theme,
    size
  } = _ref7;
  return size === 'lg' ? theme.fonts.titleSM : theme.fonts.titleXS;
}}
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.neutralL5;
}};
  user-select: none;
  width: fit-content;
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
`;
export const Subtitle = styled.span`
  ${_ref9 => {
  let {
    theme,
    size
  } = _ref9;
  return size === 'lg' ? theme.fonts.infoMD : size === 'sm' ? theme.fonts.infoXS : theme.fonts.infoSM;
}}
  color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.secondaryL2;
}};
  width: fit-content;
  user-select: none;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ContainerButton = styled.button`
  height: ${_ref11 => {
  let {
    size
  } = _ref11;
  return size === 'sm' ? '28px' : '32px';
}};
  width: ${_ref12 => {
  let {
    size
  } = _ref12;
  return size === 'sm' ? '28px' : '32px';
}};

  border: 0;
  background-color: transparent;
  outline: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
  }
`;
export const ContentAccordion = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  padding: 14px;

  margin-top: 8px;
  border-radius: 10px;

  color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.neutralL5;
}};
  ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.fonts.infoMD;
}}

  background-color: ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme.colors.secondary;
}};

  user-select: none;
`;
export const Gutter = styled.div`
  height: 8px;
`;
export const LabelContainer = styled.label`
  ${_ref16 => {
  let {
    theme
  } = _ref16;
  return theme.fonts.labelSM;
}}
  color: ${_ref17 => {
  let {
    theme
  } = _ref17;
  return theme.colors.neutralL5;
}};
  margin-bottom: 8px;
  width: fit-content;
`;